import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

const PayablesDashboard = (props) => {
  const { record } = props;
  const link = `/finance/account-payable-report-2/${record.id}/creators`;
  return (
    <Link to={link}>
      <Button
        color="primary"
        outline
        size="sm"
        style={{ margin: '0' }}
      >
        Accounts Payable Dashboard
      </Button>
    </Link>
  );
};
PayablesDashboard.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default PayablesDashboard;
